export interface ClinicUsersData {
    userRecordId: string;
    fullName: string;
    eastAsianFullName: string;
    altName: string;
    userType: string;
    mainPhone: string;
    department: string;
}

export interface ClinicUserModel {
    userId: string;
    userRecordId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    altFirstName: string;
    altLastName: string;
    credentialsCd: number;
    departmentNameCd: number;
    individualTypeCd: number;
    administratorFlg: string;
    rpCapableFlg: boolean;
    administratorFlgInBool: boolean;

    commCenterFlg: boolean;

    showAppPref: boolean;
    activatorClinicFlg: boolean;

    securityStamp: string;
    applicationAffinityCd: string;

    inboxSortPreferenceCd: number;

    contactInfo: contactInfoSection;
    afterHoursContact: AfterHoursContactSection;

    accessRx: string;
    accessRxInBool: boolean;

    canEnrollPatientFlg: string;
    canEnrollPatientFlgInBool: boolean;

    customerId: number;

    canArchiveFlg: string;
    canArchiveFlgInBool: boolean;

    assignedLocations: location[];
    availableLocations: location[];
    mainLocId: string;

    visibleLoc1: string;
    visibleLoc2: string;
    visibleLoc3: string;

    frenchHealthcareProfessionalActiveFlg: boolean;
} 
  
  export interface location {
      customerLocationId: number;
      name: string;
      primary: boolean;
  }
  
  export interface AfterHoursContactSection {
    onCallContactTypeCd: number;
    onCallEmail: string;
    onCallFax: PhoneSection;
    onCallPhone: PhoneSection;
    onCallSms: string;
  }
  export interface contactInfoSection {
    address: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    stateCd: number;
    countryCd: number;
    zipCode: string;
    mainPhone: PhoneSection;
    secondaryPhone: PhoneSection;
    clinicPhone: PhoneSection;
    clinicFax: PhoneSection;
    fax: PhoneSection;
    email: string;
    textMessageId: string;
    callContactTypeCd: number;
    patientCallSMS: string;
    smsOptedForMfaFlg ? : any;
  }
  
  export interface PhoneSection {
    defaultCountryCode: string;
    countryCode: string;
    areaCode: string;
    phoneNum: string;
    label: string;
    optedForMfaFlg ? : any;
  }
  
  export enum Mode {
    Create = 'create',
    Edit = 'edit',
    View = 'view',
    ListAll = 'list',
  }


  export interface ErrorResponse{
    fieldErrors: string[];
    actionErrors: ActionError[];
  }


  export interface ActionError{
    message: string;
    parameters: { [name: string]: ActionError };

  }